export interface ParsedGmsLookup {
  patientNum: string
  patientCodeLetter: string
}

/**
 * Parse a GMS number into PCRS lookup payload fields.
 * Supports both classic numeric cards (e.g. 0032063A) and
 * newer alphanumeric stems (e.g. 4Q93322A).
 */
export function parseGmsNumberForLookup(raw: string): ParsedGmsLookup | null {
  const normalized = String(raw || '')
    .trim()
    .replace(/[\s-]/g, '')
    .toUpperCase()

  if (!normalized) return null

  const withLetter = normalized.match(/^([A-Z0-9]+)([A-Z])$/)
  if (withLetter) {
    return {
      patientNum: withLetter[1],
      patientCodeLetter: withLetter[2],
    }
  }

  if (/^[A-Z0-9]+$/.test(normalized)) {
    return {
      patientNum: normalized,
      patientCodeLetter: 'A',
    }
  }

  return null
}
